const BackButton = ({ onClick }) => {
  return (
    <button
      className="w-32 font-be-jost-pro font-medium text-sm border border-[#FBB033] text-[#FBB033] rounded-md px-2 py-2"
      onClick={() => onClick()}
    >
      ← Go back
    </button>
  );
};

export default BackButton;
